import React, { Component } from "react";

// Material UI components
import Toolbar from "@material-ui/core/Toolbar";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import FilterIcon from "@material-ui/icons/FilterList";

class Filters extends Component {
  state = {
    filterAnchor: null,
  };

  handleFilterClick = (event) => {
    this.setState({ filterAnchor: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ filterAnchor: null });
  };

  handleFilter = (value) => (event) => {
    this.props.filterDeliveries(value);
    console.log(value);
    this.handleClose();
  };

  render() {
    const { filterAnchor } = this.state;

    return (
      <div>
        <Toolbar>
          <div />
          <Tooltip title="Filter deliveries">
            <Button
              aria-label="Filter"
              aria-controls="filter-menu"
              aria-haspopup="true"
              onClick={this.handleFilterClick}
              color="inherit"
            >
              Filter
              <FilterIcon />
            </Button>
          </Tooltip>
          <Menu
            id="filter-menu"
            anchorEl={filterAnchor}
            keepMounted
            open={Boolean(filterAnchor)}
            onClose={this.handleClose}
          >
            <MenuItem onClick={this.handleFilter("all")}>All</MenuItem>
            <MenuItem onClick={this.handleFilter("active")}>Active</MenuItem>
            <Divider />
            <MenuItem onClick={this.handleFilter("delivered")}>
              Delivered
            </MenuItem>
            <MenuItem onClick={this.handleFilter("picked_up")}>
              Picked Up
            </MenuItem>
            <MenuItem onClick={this.handleFilter("awaiting")}>
              Awaiting Pickup
            </MenuItem>
            <Divider />
            <MenuItem onClick={this.handleFilter("routed")}>Routed</MenuItem>
            <MenuItem onClick={this.handleFilter("not_routed_pickup")}>
              Not Routed for Pickup
            </MenuItem>
            <MenuItem onClick={this.handleFilter("not_routed")}>
              Not Routed
            </MenuItem>
            <Divider />
            <MenuItem onClick={this.handleFilter("failed")}>Failed</MenuItem>
          </Menu>
        </Toolbar>
      </div>
    );
  }
}

export default Filters;
